exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-button[data-v-41d18df7] {\n  margin-top: 5px;\n}\n", ""]);

// exports
